import { Button, Drawer, Space } from 'antd';
import { drawerWidth750 } from '../../../utils/constants';
import { useTranslation } from 'react-i18next';
import UpdateOrderItemForm from '../updateOrderItemForm';
import { SaveOutlined } from '@ant-design/icons';

const UpdateOrderItem = ({ open, onClose, recordData, onUpdateOrderItem }) => {
    const { t } = useTranslation();

    const saveData = async (values) => {
        onUpdateOrderItem(values);
        onClose();
    }

    return (
        <Drawer
            title={t('order.updateOrderItem')}
            width={drawerWidth750}
            onClose={onClose}
            destroyOnClose={true}
            open={open}
            extra={
                <Space className="drawerButtons">
                    <Button
                        form={"updateOrderItemForm"}
                        icon={<SaveOutlined />}
                        type="primary"
                        htmlType="submit"
                        key="submit"
                    >
                        {t('general.update')}</Button>

                    <Button key="close" onClick={onClose}>{t('general.cancel')}</Button>
                </Space>
            }
        >
            <UpdateOrderItemForm orderItemData={recordData} onFormSave={saveData} />
        </Drawer>
    );
}
export default UpdateOrderItem;